import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Sofa4",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Sofa 4",
    description: "Sofa4",
    image: require("./Sofa4.svg"),
    svgIcon: require("./Sofa4.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 200,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 200,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 48) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M34.52,18.31A7.61,7.61,0,0,1,36,18c9.24,0,18.48,0,27.71,0l3,0C76,18,85.16,18,94.34,18c1.42,0,1.84.42,1.85,1.81,0,1.08,0,2.15,0,3.17.12.09.16.15.21.15,2,.23,2.15.35,2.15,2.43q0,8.27,0,16.53a7.22,7.22,0,0,1-.07,1.13,1.2,1.2,0,0,1-1.3,1.14c-.48,0-1,0-1.55,0V48.1c0,1.25,0,1.28-1.27,1.28h-57a14.61,14.61,0,0,1-1.48,0c-.76-.08-1,.16-1,1,0,3.49,0,7,0,10.49V81.46c0,1.26,0,1.27-1.26,1.27H27.75a4,4,0,0,0-.5.07c-.38,2.4-.38,2.4-2.83,2.4H10.25c-1.84,0-2.05-.2-2.16-2,0-.12,0-.23-.08-.48H5.26c-1.39,0-1.82-.44-1.83-1.84q0-15.18,0-30.34a6.25,6.25,0,0,1,.25-1.26,2.25,2.25,0,0,0,.1-.49c-.07-.89-.23-1.78-.23-2.67q0-12.94,0-25.89c0-1.91.33-2.24,2.23-2.24L32.89,18A11.31,11.31,0,0,1,34.52,18.31ZM34.2,82.05V49.41H11V78H25.24c1.5,0,1.91.42,1.92,1.94a13.67,13.67,0,0,0,0,1.57c0,.21.28.55.44.55C29.81,82.07,32,82.05,34.2,82.05Zm.6-33.51H64.87V26.27H34.8Zm60.09-4.13c-.23,0-.43-.06-.62-.07C92.29,44.28,92,44,92,42c0-4.93,0-9.85.06-14.78,0-.72-.19-.95-.93-.93-2.33,0-4.66,0-7,0H65.56V48.57H94.89ZM34.18,48.55V26.35H11.12v22.2ZM19.2,18.6H5.65c-1.51,0-1.58.06-1.58,1.57V44.74c0,1,0,1.92,0,2.88,0,.76.31,1.13,1.1,1.11,1.31,0,2.63,0,3.94,0s1.49-.08,1.49-1.48V27c0-1.18,0-1.18,1.22-1.18H32.89c1.12,0,1.35-.23,1.35-1.32,0-1.51,0-3,0-4.54,0-1.14-.19-1.32-1.32-1.32Zm61.39,0H66.7c-1,0-1.16.16-1.17,1.17q0,2.4,0,4.8c0,1,.17,1.16,1.19,1.16H94.5c.82,0,1.17-.31,1.15-1.14,0-1.48,0-3,0-4.45s-.06-1.55-1.51-1.55ZM49.87,25.74H63.76c.81,0,1.18-.27,1.16-1.11,0-1.63,0-3.27,0-4.9,0-.81-.28-1.14-1.12-1.14q-13.94,0-27.86,0c-.85,0-1.15.36-1.14,1.15,0,1.55,0,3.09,0,4.63,0,1.22.15,1.36,1.36,1.36ZM4,65.63v15c0,1.3.11,1.41,1.37,1.42H8.68c1.67,0,1.75-.08,1.75-1.8V50.58c0-1-.25-1.29-1.29-1.29H5.3C4.15,49.29,4,49.45,4,50.6Zm7,13v1.66c0,2-.14,2.2-2.14,2.48-.05,0-.09.07-.13.11-.14,1.39,0,1.69,1,1.7,5.27,0,10.54,0,15.81.06.73,0,1.06-.3,1-1,0-1.28,0-2.56,0-3.84,0-1-.21-1.17-1.2-1.17q-6.85,0-13.71,0C11.47,78.58,11.27,78.6,11,78.62ZM92.7,26.33a1.59,1.59,0,0,0-.1.37q0,8,0,16.07a.86.86,0,0,0,1,.95h3.06c1.22,0,1.36-.14,1.36-1.35,0-3.15,0-6.3,0-9.44,0-2.68,0-5.36,0-8,0-.75-.28-1.11-1.07-1.16s-.73.5-.75,1c0,1.13-.48,1.56-1.62,1.57C94,26.34,93.36,26.33,92.7,26.33Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M34.2,82.05c-2.21,0-4.39,0-6.57,0-.16,0-.42-.34-.44-.55a13.67,13.67,0,0,1,0-1.57c0-1.52-.42-1.94-1.92-1.94H11V49.41H34.2Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M34.8,48.54V26.27H64.87V48.54Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M94.89,44.41v4.16H65.56V26.33H84.14c2.33,0,4.66,0,7,0,.74,0,.93.21.93.93C92,32.18,92,37.1,92,42c0,1.95.29,2.25,2.27,2.31C94.46,44.35,94.66,44.38,94.89,44.41Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M34.18,48.55H11.12V26.35H34.18Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M19.2,18.6H32.92c1.13,0,1.32.18,1.32,1.32,0,1.51,0,3,0,4.54,0,1.09-.23,1.32-1.35,1.32H11.82c-1.21,0-1.22,0-1.22,1.18V47.24c0,1.4-.08,1.48-1.49,1.48s-2.63,0-3.94,0c-.79,0-1.11-.35-1.1-1.11,0-1,0-1.92,0-2.88V20.17c0-1.51.07-1.57,1.58-1.57Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M80.59,18.6H94.13c1.45,0,1.51.06,1.51,1.55s0,3,0,4.45c0,.83-.33,1.15-1.15,1.14H66.72c-1,0-1.18-.16-1.19-1.16q0-2.4,0-4.8c0-1,.17-1.17,1.17-1.17Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M49.87,25.74H36.16c-1.21,0-1.36-.14-1.36-1.36,0-1.54,0-3.08,0-4.63,0-.79.29-1.15,1.14-1.15q13.92,0,27.86,0c.84,0,1.14.33,1.12,1.14,0,1.63,0,3.27,0,4.9,0,.84-.35,1.12-1.16,1.11Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M4,65.63v-15c0-1.15.16-1.31,1.31-1.31H9.14c1,0,1.28.24,1.29,1.29v29.7c0,1.72-.08,1.8-1.75,1.8H5.36C4.1,82.07,4,82,4,80.66Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M11,78.62c.32,0,.52,0,.72,0q6.85,0,13.71,0c1,0,1.19.2,1.2,1.17,0,1.28,0,2.56,0,3.84,0,.74-.32,1-1,1-5.27,0-10.54,0-15.81-.06-1,0-1.18-.31-1-1.7,0,0,.08-.1.13-.11,2-.28,2.14-.44,2.14-2.48Z"
              transform="translate(-3.43 -17.96)"
            />
            <path
              class="cls-1"
              d="M92.7,26.33c.66,0,1.26,0,1.87,0,1.14,0,1.59-.44,1.62-1.57,0-.52-.12-1.08.75-1S98,24.15,98,24.9c0,2.68,0,5.36,0,8,0,3.14,0,6.29,0,9.44,0,1.21-.14,1.34-1.36,1.35H93.58a.86.86,0,0,1-1-.95q0-8,0-16.07A1.59,1.59,0,0,1,92.7,26.33Z"
              transform="translate(-3.43 -17.96)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
